import { components } from "react-select";

const DropdownIndicator = props => {
  return (
    <components.DropdownIndicator {...props}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="8"
        height="9"
        viewBox="0 0 8 9"
        fill="none"
      >
        <path
          d="M0.538289 2.5H7.46171C7.94067 2.5 8.18015 3.07852 7.84111 3.41756L4.38075 6.88062C4.17087 7.0905 3.82913 7.0905 3.61925 6.88062L0.158886 3.41756C-0.180154 3.07852 0.0593268 2.5 0.538289 2.5Z"
          fill="#78788C"
        />
      </svg>
    </components.DropdownIndicator>
  );
};

export default DropdownIndicator;
